import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CaretLeft, MagnifyingGlass } from '@phosphor-icons/react';
import { Bell, Phone } from 'lucide-react';
import { GlobalSearch } from './global-search';
import { useTranslationWithLanguage } from '../context/language-context';

interface HeaderProps {
  title: string;
  isRTL?: boolean;
  showBackButton?: boolean;
  backTo?: string;
  showSearch?: boolean;
}

export function Header({
  title,
  isRTL = false,
  showBackButton = false,
  backTo = '/',
  showSearch = true
}: HeaderProps) {
  const navigate = useNavigate();
  const { t } = useTranslationWithLanguage();
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <header className="bg-[var(--color-gold-500)] text-white p-4 w-full fixed z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {showBackButton && (
              <button
                onClick={handleBack}
                className="mr-3 w-8 h-8 rounded-full border-2 border-white flex items-center justify-center bg-white/20"
              >
                <CaretLeft className="w-5 h-5 text-white" style={{ transform: isRTL ? 'rotate(180deg)' : 'none' }} />
              </button>
            )}
            <h1 className="text-xl font-medium">{title}</h1>
          </div>
          <div className="flex items-center gap-2">
            {showSearch && (
              <button
                onClick={() => setIsSearchOpen(true)}
                className="p-1"
                aria-label={t('common.search')}
              >
                <div className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center bg-white/20">
                  <MagnifyingGlass className="w-5 h-5 text-white" />
                </div>
              </button>
            )}
            <Link to="/notifications" className="p-1">
              <div className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center bg-white/20">
                <Bell className="w-5 h-5 text-white" />
              </div>
            </Link>
            <Link to="tel:999" className="p-1">
              <div className="w-8 h-8 rounded-full p-1 border-2 border-white flex items-center justify-center bg-white/20">
                <Phone className="w-5 h-5 text-white" />
              </div>
            </Link>
          </div>
        </div>
      </header>

      <GlobalSearch isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  );
}
